import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import {breakpoints} from "../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  filters: {
    margin: "32px 0 24px 0",
    display:"flex",
    justifyContent:"space-between",
    [`@media (max-width: ${breakpoints.xl}px)`]:{
      justifyContent:"space-between",
      flexDirection: "column"
    },
  },
  filterGroups: {
    display: 'flex',
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginBottom: "10px"
    }
  },
  filterContainer:{
    display:"flex",
    justifyContent:"space-between",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      flexDirection: "column"
    }
  },
  filter: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    width: "fit-content",
    display: "inline-block",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "10px 10px"
    }
  },
  thisMonth: {
    extend: "filter",
    borderTopRightRadius: "0",
    borderBottomRightRadius: "0",
  },
  thisWeek: {
    extend: "filter",
    borderLeft: "none",
    borderRadius: "0",
    "&:hover, &:focus": {
      borderLeft: "none"
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      borderTopRightRadius: "8px",
      borderBottomRightRadius: "8px"
    }
  },
  yesterday: {
    extend: "filter",
    borderRight: "none",
    borderRadius: "0",
    borderLeft: "none",
    "&:hover, &:focus": {
      borderLeft: "none",
      borderRight: "none",
      [`@media (max-width: ${breakpoints.md}px)`]: {
        borderLeft: `1px solid ${colors.darkGrey}`,
      }
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      borderLeft: `1px solid ${colors.darkGrey}`,
      borderTopLeftRadius: "8px",
      borderBottomLeftRadius: "8px"
    }
  },
  today: {
    extend: "filter",
    borderTopLeftRadius: "0",
    borderBottomLeftRadius: "0"
  },
  active: {
    backgroundColor: colors.brightBlue + " !important",
    pointerEvents: "none"
  },
  filterButtons:{
    display:"flex",
    flexDirection:"row",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      gap:"10px"
    },
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      display: "grid",
      gap: 0
    },
  },
  buttonContainer:{
    display:"flex",
    justifyContent:"flex-end",
    alignItems:"center",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      display: "grid",
      justifyContent:"flex-start",
      marginTop:"10px"
    },
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      marginTop:"12px",
      justifyContent:"flex-start",
    },
    "& div:first-of-type": {
      display: "flex",
      alignItems: "center"
    },
  },
  toggleStyle:{

  }
}));

export default styles;
